import React, { Fragment } from 'react';
import Tooltip from './Tooltip'

const InputField = ({
    name,
    id,
    type = 'text',
    value,
    minValue = null,
    maxValue = null,
    label,
    onChange,
    errors = {},
    containerCssClass = '',
    inputCssClass,
    labelCssClass = '',
    autoComplete = null,
    placeholder = null,
    maxLength = 200,
    required,
    disabled,
    checked,
    textInputPrefix,
    tooltip = null
}) => {
    return (
        <label className={containerCssClass} htmlFor={id}>
            {textInputPrefix ? (
                <Fragment>
                    {label &&
                        <span className={`${labelCssClass} ${required ? 'label-required' : ''}`}>{label}</span>
                    }
                    {tooltip &&                
                        <Tooltip text={tooltip} />                     
                    }
                    <div className="form-input-prefix">
                        <span>{textInputPrefix}</span>
                        <input
                            className={`${inputCssClass ? inputCssClass : ''}${errors[id] ? ' invalid' : ''}`}
                            disabled={disabled}
                            id={id}
                            name={name}
                            type={type}
                            value={value ?? ''}
                            min={minValue}
                            max={maxValue}
                            placeholder={placeholder}
                            autoComplete={autoComplete}
                            onChange={(event) => onChange(event.target.value)}
                            maxLength={maxLength}
                        />
                    </div>
                </Fragment>
            ) : (
                <Fragment>
                    {(type !== 'checkbox' && type !== 'radio' && label) &&
                        <span className={`${labelCssClass} ${required ? 'label-required' : ''}`}>{label}</span>            
                    }
                    {tooltip &&
                        <Tooltip text={tooltip} />                     
                    }
                    <input
                        className={`${inputCssClass ? inputCssClass : ''}${errors[id] ? ' invalid' : ''}`}
                        disabled={disabled}
                        checked={checked}
                        id={id}
                        name={name}
                        type={type}
                        value={value ?? ''}
                        min={minValue}
                        max={maxValue}
                        placeholder={placeholder}
                        autoComplete={autoComplete}
                        onChange={(event) => onChange(type === 'checkbox' ? event.target.checked : event.target.value)}
                        maxLength={maxLength}
                    />
                    {((type === 'checkbox' || type === 'radio') && label) &&
                        <span className={`${labelCssClass} ${required ? 'label-required' : ''}`}>{label}</span>            
                    }
                </Fragment>
            )}
            {errors[id] && 
                <div className="validation-message" data-error-for={id}>
                    {errors[id][0]}
                </div>
            }
        </label>
    );
};

export default InputField;
